import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-disclaimer-msg',
  templateUrl:'./disclaimer-msg.component.html',
  styleUrls: ['./disclaimer-msg.component.scss'],
})
export class DisclaimerMsgComponent {
  helpLink:string = `${environment.coreAIBotURL}/image/Scout_Overview.pdf`;
  termsLink:string = `${environment.coreAIBotURL}/image/TermsOfUse_Scout.pdf`;

  ngOnInit() {
   
  }

}